/* tslint:disable */
/* eslint-disable */
/* Mocked in-memory implementation of ConversionsClient for local development and UI wiring. */

import { CancelToken } from 'axios';
import {
  GetConversionsResponseDto,
  ImportConversionsRequestDto,
  GetExistingConversionsResponseDto,
} from '../../types';

/* ---- Helper Functions ---- */

function delay(ms: number = 300): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/* ---- Mock Data ---- */

const mockConversions = [
  { id: 1, itemNumber: 'ITEM001', fromUom: 'Each', toUom: 'Case', factor: 12 },
  { id: 2, itemNumber: 'ITEM002', fromUom: 'Kg', toUom: 'g', factor: 1000 },
  { id: 3, itemNumber: 'ITEM003', fromUom: 'Litre', toUom: 'ml', factor: 1000 },
];

/* ---- Mocked Client Implementation ---- */

import { IConversionsClient } from '../../interfaces';
export class ConversionsClientMocked implements IConversionsClient {
  constructor(baseUrl?: string) {}

  async conversions(
    search?: string,
    uomClass?: string,
    skip?: number,
    take?: number,
    storeNumber?: string,
    cancelToken?: CancelToken
  ): Promise<GetConversionsResponseDto> {
    await delay();
    let filtered = [...mockConversions];
    if (search) {
      filtered = filtered.filter((c) => c.itemNumber.toLowerCase().includes(search.toLowerCase()));
    }
    const start = skip || 0;
    const end = start + (take || 10);
    return {
      conversions: filtered.slice(start, end),
      totalCount: filtered.length,
    } as GetConversionsResponseDto;
  }

  async import(body?: ImportConversionsRequestDto, cancelToken?: CancelToken): Promise<void> {
    await delay();
    if (body && body.conversions) {
      body.conversions.forEach((conv) => {
        mockConversions.push({
          id: mockConversions.length + 1,
          itemNumber: conv.itemNumber || '',
          fromUom: conv.fromUom || '',
          toUom: conv.toUom || '',
          factor: conv.conversionNumber || 1,
        });
      });
    }
  }

  async existingconversions(
    itemNumber?: string,
    storeNumbers?: string[],
    uom?: string,
    cancelToken?: CancelToken
  ): Promise<GetExistingConversionsResponseDto> {
    await delay();
    const filtered = mockConversions.filter((c) => !itemNumber || c.itemNumber === itemNumber);
    return { conversions: filtered } as GetExistingConversionsResponseDto;
  }

  // ====== Auto-generated stub methods ======






}
